import { createReducer, on } from '@ngrx/store';

import { CategoryGrid } from '../models/grid.models';

import {
    ChangeCategory,
    SetTotalQuantityProducts,
    LoadNextPageStudioSuccess,
    LoadFirstPageStudio,
    LoadNextPageGridSuccess,
    LoadFirstPageGrid,
    LoadFirstPageNewCollection,
    LoadNextPageGridNewCollectionSuccess,
    LoadNextPageStudioNewCollectionSuccess,
    LoadLastPageGridSuccess,
    LoadNewCollectionCategoryProducts,
    SetProductIdsPageGrid,
} from './category-grid.actions';
import { InitialCategoryGrid } from './category-grid.state';

export const CategoryGridReducer = createReducer(
    InitialCategoryGrid,

    on(ChangeCategory, (_, { category }): CategoryGrid => {
        return {
            ...InitialCategoryGrid,
            categoryId: category.id,
        };
    }),

    on(SetTotalQuantityProducts, (state, payload): CategoryGrid => {
        return { ...state, totalQuantityProducts: payload.totalQuantityProducts };
    }),

    on(LoadNextPageGridSuccess, (state, payload): CategoryGrid => {
        return {
            ...state,
            gridDefault: {
                ...state.gridDefault,
                currentPage: payload.page,
                pageProductIds: [
                    ...state.gridDefault.pageProductIds,
                    ...payload.ids,
                ],
            },
        };
    }),

    on(LoadNextPageStudioSuccess, (state, payload): CategoryGrid => {
        return {
            ...state,
            gridStudio: {
                ...state.gridStudio,
                currentPage: payload.page,
                pageGridElements: [
                    ...state.gridStudio.pageGridElements,
                    ...payload.ids,
                ],
            },
        };
    }),

    on(LoadNextPageGridNewCollectionSuccess, (state, payload): CategoryGrid => {
        return {
            ...state,
            gridNewCollection: {
                default: {
                    ...state.gridNewCollection.default,
                    currentPage: payload.page,
                    pageProductIds: [
                        ...state.gridNewCollection.default.pageProductIds,
                        ...payload.ids,
                    ],
                },
                studio: state.gridNewCollection.studio,
                title: state.gridNewCollection.title,
            },
        };
    }),

    on(LoadNextPageStudioNewCollectionSuccess, (state, payload): CategoryGrid => {
        return {
            ...state,
            gridNewCollection: {
                default: state.gridNewCollection.default,
                studio: {
                    ...state.gridNewCollection.studio,
                    currentPage: payload.page,
                    pageGridElements: [
                        ...state.gridNewCollection.studio.pageGridElements,
                        ...payload.ids,
                    ],
                },
                title: state.gridNewCollection.title,
            },
        };
    }),

    on(LoadFirstPageStudio, (state, { grid }): CategoryGrid => {
        return {
            ...state,
            gridStudio: grid,
        };
    }),

    on(LoadFirstPageNewCollection, (state, { grid }): CategoryGrid => {
        return {
            ...state,
            gridNewCollection: {
                ...state.gridNewCollection,
                default: grid.default,
                studio: grid.studio,
            },
        };
    }),

    on(LoadFirstPageGrid, (state, { grid }): CategoryGrid => {
        return {
            ...state,
            gridDefault: grid,
        };
    }),

    on(LoadLastPageGridSuccess, (state): CategoryGrid => {
        return {
            ...state,
            gridDefault: {
                ...state.gridDefault,
                productsFullyLoaded: true,
            },
        };
    }),

    on(LoadNewCollectionCategoryProducts, (state, { title }): CategoryGrid => {
        return {
            ...state,
            gridNewCollection: {
                ...state.gridNewCollection,
                title,
            },
        };
    }),

    on(SetProductIdsPageGrid, (state, { productsId }): CategoryGrid => {
        return {
            ...state,
            gridDefault: {
                ...state.gridDefault,
                idsFiltered: productsId,
                pageProductIds: productsId.slice(0, state.gridDefault.pageProductIds.length),
            },
        };
    }),
);
